module.exports = __webpack_public_path__ + "static/media/instruction02.ac072683.png";